import type { SearchBadgeConfig } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { COLOR_CATEGORY, getColor } from '@/lib/color-registry'
import { getTagGroupColor } from '@/lib/tag-utils'
import type { SearchToken } from './types'

export const opportunitySearchBadgeConfig: SearchBadgeConfig<SearchToken> = {
  tag: {
    label: (t) => (t.group ? `${t.group}:${t.value}` : t.value),
    color: 'none',
    className: (t) => getTagGroupColor(t.group),
  },
  exclude_tag: {
    label: (t) => `tag除外:${t.group ? `${t.group}:${t.value}` : t.value}`,
    color: 'none',
    className: (t) => getTagGroupColor(t.group),
  },
  customer: {
    label: (t) => `取引先:${t.name}`,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'customer'),
  },
  vertical_division: {
    label: (t) => `縦組織:${t.name}`,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'vertical_division'),
  },
  lateral_division: {
    label: (t) => `横組織:${t.name}`,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'lateral_division'),
  },
  created_by: {
    label: (t) => `起票者:${t.name}`,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'created_by'),
  },
  sales_recording_group: {
    label: (t) => `売上計上:${t.name}`,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'sales_recording_group'),
  },
  opportunity_status_id: {
    label: (t) => `ステータス:${t.name}`,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'opportunity_status_id'),
  },
  opportunity_type: {
    label: (t) => `オポ種別:${t.name}`,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'opportunity_type'),
  },
  incentive_filter: {
    label: (t) => `インセンティブ${t.filter === 'target' ? '対象のみ' : '対象外'}`,
    color: (t) => getColor(COLOR_CATEGORY.INCENTIVE_FILTER, t.filter),
  },
  exclude: {
    label: (t) => `除外:${t.value}`,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'exclude'),
  },
  query: {
    label: (t) => t.value,
    color: getColor(COLOR_CATEGORY.SEARCH_TOKEN, 'query'),
    darkRemoveButton: true,
  },
}
